import { render, staticRenderFns } from "./DescriptionOfCharacteristics.vue?vue&type=template&id=7c036144&"
import script from "./DescriptionOfCharacteristics.vue?vue&type=script&lang=js&"
export * from "./DescriptionOfCharacteristics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports